export default __webpack_public_path__ + "static/roberta-97abdcf50e19610401bc111e83ff5913.jpg";